const state = {
  image: null,
  title: null
}

const mutations = {
  setToolbar (state, { image, title } = {}) {
    state.image = image
    state.title = title
  }
}

export default {
  namespaced: true,
  mutations,
  state
}
